exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.pastGreyedOut {\r\n\tbackground-color: white;\r\n  color: grey;\r\n  height: 100%;\r\n}\r\n\r\n.modal-footer {\r\n  -ms-flex-pack: center;\r\n      justify-content: center;\r\n}\r\n\r\n.lunchOrNoLunch {\r\n  width: 90%;\r\n}\r\n\r\n\r\n.paddingCalendar {\r\n  padding: 5px;\r\n  border-radius: 5px;\r\n  background-color: white;\r\n}\r\n\r\n.standardLunchDay {\r\n  background-color: green;\r\n}\r\n\r\n.noStandardLunchDay {\r\n  background-color: red;\r\n}\r\n\r\n\r\n.custom-day {\r\n  text-align: center;\r\n  padding: 0.185rem 0.25rem;\r\n  display: inline-block;\r\n  height: 2rem;\r\n  width: 2rem;\r\n}\r\n.custom-day.focused {\r\n  background-color: #e6e6e6;\r\n}\r\n.custom-day.range, .custom-day:hover {\r\n  background-color: rgb(2, 117, 216);\r\n  color: white;\r\n}\r\n.custom-day.faded {\r\n  background-color: rgba(2, 117, 216, 0.5);\r\n}\r\n\r\n.isFuture {\r\n  height: 100%;\r\n}\r\n\r\n.cal-day-badge {\r\n  background-color: rgb(243, 91, 10);\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/submit/submit.component.css
// module id = ./src/app/submit/submit.component.css
// module chunks = 1